import { EditorState, PluginKey } from 'prosemirror-state'
import { InlineFormatBarPluginState } from 'common/Prose/Plugins/InlineFormatBarPlugin/Types'

export const InlineFormatBarPluginKey = new PluginKey<InlineFormatBarPluginState>('InlineFormatBar')

export function getInlineFormatBarPluginState(editorState: EditorState) {
  const pluginState = InlineFormatBarPluginKey.getState(editorState)
  if (!pluginState) {
    throw new Error('Inline format bar plugin is not registered on the current editor state.')
  }
  return pluginState
}
